import React from 'react';

const PauseIcon = () => {
  return (
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" fill="#0274ff" viewBox="0 0 24 24" strokeWidth={1.5} stroke="#f2f1f4" className="w-12 h-12">
        <path strokeLinecap="round" strokeLinejoin="round" d="M14.25 9v6m-4.5 0V9M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    </div>
  )
}

export default PauseIcon;
